var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceGuard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.8,6c50.7,35.6,106.6,59.3,165.7,71.2c15.2,3.4,32.1,5.1,47.4,5.1c5.1,0,10.1,1.7,15.2,1.7 c-3.4,89.8-18.6,164.4-49,228.8c-37.2,79.7-98.1,145.8-181,193.2c-50.7-23.7-94.7-55.9-128.5-93.2c-11.8-13.6-23.7-28.8-33.8-45.8 c-25.4-40.7-44-88.1-55.8-142.4c-6.8-32.2-10.1-67.8-10.1-105.1V85.7c55.8-5.1,104.9-15.3,150.5-35.6c11.8-5.1,25.4-10.2,37.2-17 c11.8-6.8,23.7-13.6,35.5-22L256.8,6z M251.5,68.2c-9,6.5-18.1,11.7-27.1,16.9c-9,5.2-19.4,9.1-28.4,13 c-34.9,15.6-72.3,23.4-114.9,27.3v26c0,28.6,2.6,55.9,7.7,80.6c9,41.6,23.2,78,42.6,109.2c7.7,13,16.8,24.7,25.8,35.1 c25.8,28.6,59.4,53.3,98.2,71.5c63.3-36.4,109.8-87.1,138.2-148.1c23.2-49.4,34.9-106.6,37.5-175.4c-3.9,0-7.7-1.3-11.6-1.3 c-11.6,0-24.5-1.3-36.2-3.9c-45.2-9.1-87.8-27.3-126.6-54.6L251.5,68.2z M324.8,187.1c8.1-8.2,21.2-8.2,29.3,0 c8.1,8.2,8.1,21.4,0,29.5l-97.9,98.9c-4.7,4.7-10.8,7.1-17,7.1c-6.1,0-12.3-2.4-17-7.1l-47.8-48.3c-8.1-8.2-8.1-21.4,0-29.5 c8.1-8.2,21.2-8.2,29.3,0l35.4,35.8L324.8,187.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceGuard);
export default __webpack_public_path__ + "static/media/service-guard.c269652510d8b42abcfd2adbd212bd83.svg";
export { ForwardRef as ReactComponent };